import { Modal } from '@pmi/dsm-react';
import { useState } from 'react';
import { User } from '../../../../../../shared/models/UserModels';
import RegisteredUsers from './RegisteredUsers';

export default function DisableAccessModal({
  selectedUsers,
  onSubmit,
  onCancel,
}: {
  selectedUsers: User[];
  onSubmit: (e: Event | any) => void;
  onCancel: () => void;
}) {
  const [processing, setProcessing] = useState(false);
  const onRemoved = (e: Event | any) => {
    onSubmit(e);
    setProcessing(true);
  };
  return (
    <Modal
      buttons={[
        {
          titleText: 'Cancel',
          variant: 'outline-secondary',
          onClick: onCancel,
          disabled: processing,
        },
        { titleText: 'Yes, Disable', variant: 'primary', onClick: onRemoved },
      ]}
      onClose={onCancel}
      variant="dialog"
      headline="Disable Access"
      description={`Are you sure you want to disable access for ${
        selectedUsers.length
      } user${selectedUsers.length > 1 ? 's' : ''}?
They will no longer be able to access your Partner Platform or activate products that you are offering, but you can enable their access at any time in the future.`}
      show
    >
      <p>
        {selectedUsers.length} user{selectedUsers.length > 1 ? 's' : ''}{' '}
        accounts will be revoked upon removal.
      </p>
      <RegisteredUsers users={selectedUsers} />
    </Modal>
  );
}
